<template lang="pug">
label._checkbox(:class="{'nonClickable' : disabled}" :style='{opacity: disabled ? ".5" : "1"}')
    //- input(type="checkbox" :checked='modelValue' @input="e=>{modelValue = e.target.checked;$emit('update:modelValue', e.target.checked)}" :disabled="disabled" :name="name" hidden)
    input(type="checkbox" :checked='modelValue' @input.stop="e=>{$emit('update:modelValue', e.target.checked)}" :disabled="disabled" :name="name" hidden)
    template(v-if="modelValue === null")
        svg.svgIcon.white(:class='{fill:modelValue !== null}')
            use(xlink:href="/material-icon.svg#icon-minus-square")
    template(v-else-if="modelValue")
        svg.svgIcon.white(:class='{fill:modelValue !== null}')
            use(xlink:href="/material-icon.svg#icon-check-square")
    template(v-else)
        svg.svgIcon.white(:class='{fill:modelValue !== null}')
            use(xlink:href="/material-icon.svg#icon-square")

    div(style="white-space: nowrap")
        slot
</template>
<script setup>
import { ref, onMounted, useSlots } from "vue";
let {
    disabled,
    modelValue = ref(false),
    name,
} = defineProps({
    disabled: Boolean,
    modelValue: {
        type: Boolean,
        default: false,
    },
    name: String,
});

const emit = defineEmits(["update:modelValue"]);
const slots = useSlots();
let hasSlotContent = ref(false);
onMounted(() => {
    hasSlotContent.value = !!slots.default && slots.default().length > 0;
});
</script>
<style lang="less" scoped>
label._checkbox {
    position: relative;
    display: inline-flex;
    // align-items: flex-start;
    align-items: center;
    flex-wrap: nowrap;
    cursor: pointer;
    user-select: none;

    &>div {
        // font-size: 0.8rem;
        font-size: 1rem;
        font-weight: 300;
        // white-space: nowrap;
        white-space: break-spaces;
    }

    span+div:not(:empty) {
        margin-left: 4px;
    }

    input:checked+* {
        // color: var(--main-color);
        color: inherit;
    }

    svg {
        margin-right: 4px;
        width: 22px;
        height: 22px;
        flex: none;
    }
}

@media (max-width: 430px) {
    label._checkbox {
        // align-items: unset;

        &>div {
            // white-space: wrap;
            // margin-top: 4px;
        }
    }
}
</style>
